import React, { useState } from "react";
import cn from "classnames";
import styles from "./Settings.module.sass";
import Dropdown from "../../../components/Dropdown";
import Checkbox from "../../../components/Checkbox";

// Options pour le tri
const sortingOptions = ["Plus récentes", "Plus anciennes"];

// Types de contrat
const contractTypes = [
  "Apprentissage",
  "Professionnalisation"
];

// Statuts des offres
const statusOptions = [
  "Publiée",
  "En cours de traitement",
  "En attente de retour",
  "Cloturé"
];

const Settings = ({ onFiltersChange }) => {
  const [search, setSearch] = useState("");
  const [sorting, setSorting] = useState(sortingOptions[0]);
  const [selectedContractTypes, setSelectedContractTypes] = useState([]);
  const [selectedStatuses, setSelectedStatuses] = useState([]);

  const handleSubmit = (e) => {
    e.preventDefault();
    applyFilters();
  };

  const handleContractTypeChange = (contractType) => {
    if (selectedContractTypes.includes(contractType)) {
      setSelectedContractTypes(selectedContractTypes.filter((x) => x !== contractType));
    } else {
      setSelectedContractTypes([...selectedContractTypes, contractType]);
    }
  };

  const handleStatusChange = (status) => {
    if (selectedStatuses.includes(status)) {
      setSelectedStatuses(selectedStatuses.filter((x) => x !== status));
    } else {
      setSelectedStatuses([...selectedStatuses, status]);
    }
  };

  const resetFilters = () => {
    setSearch("");
    setSorting(sortingOptions[0]);
    setSelectedContractTypes([]);
    setSelectedStatuses([]);
    if (onFiltersChange) {
      onFiltersChange({
        search: "",
        sorting: sortingOptions[0],
        contractTypes: [],
        statuses: []
      });
    }
  };

  const applyFilters = () => {
    console.log('Filtres appliqués:', {
      search,
      sorting,
      contractTypes: selectedContractTypes,
      statuses: selectedStatuses
    });
    
    if (onFiltersChange) {
      onFiltersChange({
        search,
        sorting,
        contractTypes: selectedContractTypes,
        statuses: selectedStatuses
      });
    }
  };

  return (
    <div className={styles.settings}>
      <div className={styles.group}>
        <div className={styles.item}>
          <Dropdown
            className={styles.dropdown}
            classDropdownLabel={styles.label}
            value={sorting}
            setValue={setSorting}
            options={sortingOptions}
            label="Trier par"
          />
        </div>
        <div className={styles.item}>
          <div className={styles.label}>Type de contrat</div>
          <div className={styles.list}>
            {contractTypes.map((contractType, index) => (
              <Checkbox
                className={styles.checkbox}
                content={contractType}
                value={selectedContractTypes.includes(contractType)}
                onChange={() => handleContractTypeChange(contractType)}
                key={index}
                reverse
              />
            ))}
          </div>
        </div>
        <div className={styles.item}>
          <div className={styles.label}>Statut</div>
          <div className={styles.list}>
            {statusOptions.map((status, index) => (
              <Checkbox
                className={styles.checkbox}
                content={status}
                value={selectedStatuses.includes(status)}
                onChange={() => handleStatusChange(status)}
                key={index}
                reverse
              />
            ))}
          </div>
        </div>
        <div className={styles.btns}>
          <button 
            className={cn("button-stroke", styles.button)}
            onClick={resetFilters}
          >
            Réinitialiser
          </button>
          <button 
            className={cn("button", styles.button)}
            onClick={applyFilters}
          >
            Appliquer
          </button>
        </div>
      </div>
    </div>
  );
};

export default Settings;
